// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  margin-top: 10px;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  background-color: #f4ffdf;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/main/errorsPages/404/error-404.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AACF","sourcesContent":[".main {\r\n  margin-top: 10px;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  width: 100%;\r\n  background-color: #f4ffdf;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
